import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Raceto2() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "race2";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"Race To 2nd"}
    >
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Player A</div>
              <div className="casino-odds-box back">
                {/* <span className="casino-odds">2.17</span> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player A", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Player A", casinoData, true)}
                  </span>
                </div>
              </div>
              <div className="casino-odds-box lay">
                {/* <span className="casino-odds">2.33</span> */}
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player A", casinoData, dispatch, "lay")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Player A", casinoData, false)}
                  </span>
                </div>
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Player B</div>
              <div className="casino-odds-box back">
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player B", casinoData, dispatch, "back")
                  }
                >
                  {/* <span className="casino-odds">2.38</span> */}
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Player B", casinoData, true)}
                  </span>
                </div>
              </div>
              <div className="casino-odds-box lay">
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player B", casinoData, dispatch, "lay")
                  }
                >
                  {/* <span className="casino-odds">2.56</span> */}
                  <span className="casino-odds">
                    {getOddForEntity("Player B", casinoData, false)}
                  </span>
                </div>
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Player C</div>
              <div className="casino-odds-box back">
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player C", casinoData, dispatch, "back")
                  }
                >
                  {/* <span className="casino-odds">12.14</span> */}
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Player C", casinoData, true)}
                  </span>
                </div>
              </div>
              <div className="casino-odds-box lay">
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player C", casinoData, dispatch, "lay")
                  }
                >
                  {/* <span className="casino-odds">14.34</span> */}
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Player C", casinoData, false)}
                  </span>
                </div>
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Player C")}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Player D</div>
              <div className="casino-odds-box back">
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player D", casinoData, dispatch, "back")
                  }
                >
                  {/* <span className="casino-odds">12.14</span> */}
                  <span className="casino-odds">
                    {/* <span className="casino-box-odd">  */}{" "}
                    {getOddForEntity("Player D", casinoData, true)}
                  </span>
                </div>
              </div>
              <div className="casino-odds-box lay">
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Player D", casinoData, dispatch, "lay")
                  }
                >
                  {/* <span className="casino-odds">14.34</span> */}
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Player D", casinoData, false)}
                  </span>
                </div>
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Player D")}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
          <span>Last Result</span>
          <span>
            <a href="/casino-results/race2">View All</a>
          </span>
        </div> */}
        {/* <div className="casino-last-results">
          <span className="result result-b">D</span>
          <span className="result result-b">B</span>
          <span className="result result-b">C</span>
          <span className="result result-b">D</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-b">A</span>
          <span className="result result-b">A</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
        
          <div className="d-none">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div> */}
      </div>
    </CasinoPage>
  );
}
